module.exports = __webpack_public_path__ + "static/video-c0279725c7cbc1f737165b1120f5375f.mp4";